export const ROUTES = {
  // Dashboard & Core
  DASHBOARD: "/",
  GET_STARTED: "/get-started",
  LOGIN_CODE: "/login-code",
  LOGIN: "/login",
  ALL_SET: "/allset",

  // Onboarding Flow
  ONBOARDING_1: "/Onboarding",
  ONBOARDING_2: "/Onboarding-Header",
  ONBOARDING_3: "/Onboarding-Header1",
  ONBOARDING_4: "/Onboarding-Header2",
  ONBOARDING_5: "/Onboarding-Header3",
  ONBOARDING_6: "/Onboarding-Header4",
  ONBOARDING_7: "/Onboarding-Header5",
  ONBOARDING_REMINDERS: "/Onboarding-Reminders",
  TWO_FA: "/TwoFA",

  // Profile
  PROFILE: "/profile",
  PROFILE_EDIT: "/profile/edit",
  PROFILE_LANGUAGE: "/profile/language",
  PROFILE_PASSWORD: "/profile/password",
  PROFILE_NOTIFICATION: "/profile/notification",

  // Sherpa / Chat
  SHERPA: "/sherpa",
  SHERPA_DASHBOARD: "/sherpa-dashboard",
  DISCLAIMER: "/disclamer",
  SIDEBAR_MOBILE: "/SidebarMobile",

  // Assessment
  ASSESSMENT_DASHBOARD: "/assessment-dashboard",
  PEARLI_REPORTS: "/PEARLIReports",
  PHYSICAL_ASSESSMENT: "/Assessment/maincontent/:domain",
  PHYSICAL_DOMAIN: "/Question-card/:domain",
  ASSESSMENT_DISCLAIMER: "/Disclaimer",

  // Mindfulness & Exercises
  MINDFULNESS: "/mindfulness",
  EXERCISES: "/exercises/:id",

  // Admin
  ADMIN_INDEX: "/admin",
  ADMIN_ANALYTICS: "/admin/analytics",
  ADMIN_ASSESSMENT_ANALYTICS: "/admin/assessment-analytics",
  ADMIN_USER_MANAGEMENT: "/admin/usermanagement",

  // Live Events
  LIVE_MAIN: "/live",
  LIVE_REGISTER: "/live/register/:event/:ID",
  LIVE_JOIN: "/live/join/:ID",

  // Home & Tour
  HOME: "/Home",
  HOME_MAIN_CONTENT: "/HomeMaincontent",
  TOUR: "/tour",

  // Auth & Password
  PASSWORD: "/password",
  PASSWORD_ID: "/password/:id",
  RESET_PASSWORD: "/ResetPassword",
  RESET_PASSWORD_ID: "/ResetPassword/:id",

  // Business / Company
  REGISTER_COMPANY: "/RegisterCompany",
  CONFIRM_BUSINESS: "/ConfirmBusiness",
  TERMS_CONDITIONS: "/TermsConditions",
  PRICING: "/Pricing",

  // Courses
  COURSES: "/Courses",

  // Misc
  TAKE_DEEP_BREATH: "/TakeDeepBreath",
};